/* eslint-disable react/no-array-index-key */
import { Dialog, Grid } from '@material-ui/core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import ArrowDownIcon from '../../icons/arrow-down';
import RequestRefundIcon from '../../icons/request-refund';
import formatCurrency from '../../utils/formatCurrency';
import GcpTypography from '../gcp-typography';
import {
  Amount,
  Container,
  Description,
  SelectWrapper,
  StyledButton,
  TextareaWrapper,
  Title,
} from './style';
import useViewModel from './viewmodel';

type RequestRefundDialogProps = {
  amount: number;
  open: boolean;
  requestTypes: string[];
  error: string;
  onCancel?: () => void;
  onSubmit: (reasonType: string, reason: string) => void;
};

const RequestRefundDialog: FC<RequestRefundDialogProps> = (props) => {
  const { amount, open, requestTypes, error, onCancel, onSubmit } = props;
  const { t } = useTranslation();
  const {
    reasonType,
    reason,
    reasonLength,
    handleReasonTypeChange,
    handleReasonChange,
    handleSubmit,
    clearFields,
  } = useViewModel({ onCancel, onSubmit });

  return (
    <Dialog open={open}>
      <Container>
        <RequestRefundIcon />
        <div>
          <Title>{t('request_refund.request_refund_dialog_title')}</Title>
          <Description>
            {t('request_refund.request_refund_dialog_description')}
          </Description>
        </div>
        <Amount>
          <span>{t('request_refund.amount')}</span>
          <span>PHP {formatCurrency(amount)}</span>
        </Amount>
        <SelectWrapper selected={Boolean(reasonType)}>
          <select defaultValue="none" onChange={handleReasonTypeChange}>
            <option disabled hidden value="none">
              {t('request_refund.reason_type_placeholder')}
            </option>
            {requestTypes.map((REASON_TYPE) => (
              <option key={REASON_TYPE} value={REASON_TYPE}>
                {REASON_TYPE}
              </option>
            ))}
          </select>
          <ArrowDownIcon className="arrow-down-icon" />
        </SelectWrapper>
        <TextareaWrapper>
          <textarea
            maxLength={100}
            placeholder={t('request_refund.reason_placeholder')}
            onChange={handleReasonChange}
          />
          <div className="textarea-char-count">{reasonLength}/100</div>
        </TextareaWrapper>
        <Grid container justify="space-between" spacing={1}>
          <Grid item xs={6}>
            <StyledButton size="small" variant="outlined" onClick={clearFields}>
              {t('dialog.cancel')}
            </StyledButton>
          </Grid>
          <Grid item xs={6}>
            <StyledButton
              color="primary"
              disabled={!reasonType || !reason}
              size="small"
              variant="contained"
              onClick={handleSubmit}
            >
              {t('request_refund.request_refund_btn')}
            </StyledButton>
          </Grid>
          {error && (
            <GcpTypography paint="ceriseRed" textAlign="right">
              {error}
            </GcpTypography>
          )}
        </Grid>
      </Container>
    </Dialog>
  );
};

export default RequestRefundDialog;
